import React, { useState, useEffect } from "react";
import { format } from 'date-fns';
import Menu from "../../../components/layout/menu/index"
import IndicatorGauge from "../../../components/dashboards/radialBarChart";
import PieChartOrders from "../../../components/dashboards/pieChart";
import DeliveryAverageChart from "../../../components/dashboards/deliveryAverageChart";
import PieChartBilling from "../../../components/dashboards/billingChart";
import ResetFilters from "../../../components/filters/resetFilters";
import ListFilter from "../../../components/filters/listFilters";
import BarChartData from "../../../components/dashboards/barChart";
import { getUserAdherence, exportExcelAdherence } from "../../../client/userAdherence";
import { useAuth } from "../../../context/auth";
import { getPendingDelivery, getAverageDeliveryDays, getComplianceIndicator, getQuantityMaterialOrders, getBilling } from "../../../client/purchaseOrder";
import { getHesEvaluation, getSupplierPosition } from "../../../client/evaluation";
import BarChartATC from "../../../components/dashboards/barChartATC";
import {getAtcDashboardData, getCountEmptyAtcs } from "../../../client/atc/index"
import AtcVaciasChart from "../../../components/dashboards/atcVaciasChart";
export default function HomeAdmin() {
  const { user } = useAuth();
  const roleId= user?.roleId;
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [adherenceData, setAdherenceData] = useState([]);
  const [pendingDelivery, setPendingDelivery] = useState([]);
  const [loading, setLoading] = useState(true);
  const { supplierId } = useAuth();
  const [complianceIndicator, setComplianceIndicator] = useState(0);
  const [quantityMaterialOrders, setQuantityMaterialOrders] = useState(null);
  const [billing, setBilling] = useState(null);
  const [hesEvaluation, setHesEvaluation] = useState(0);
  const [deliveryAverages, setDeliveryAverages] = useState(null);
  const [selectedCategories, setSelectedCategories] = useState(null);
  const [selectedSuppliers, setSelectedSuppliers] = useState(null);
  const [activeDates, setActiveDates] = useState(null);
  const [resetFlag, setResetFlag] = useState(false);
  // Filtros aplicados con "Aplicar"; ListFilter los usa para saber si hay filtros activos
  const [appliedFilters, setAppliedFilters] = useState({});
  const [exporting, setExporting] = useState(false);

  const [atcData, setAtcData] = useState(null);
  const [loadingAtc, setLoadingAtc] = useState(true);
  const [atcChartData, setAtcChartData] = useState([]);

const [emptyAtcCount, setEmptyAtcCount] = useState(null);


  const [filterOptions, setFilterOptions] = useState([
    {
      title: "Proveedor:",
      options: ["Todos", "Aceptado", "Nueva", "Pendiente", "Rechazado"]
    },
    {
      title: "Fecha:",
      type: "dateRange"
    },
  ]);

  const [loadingAdherence, setLoadingAdherence] = useState(true);
  const [loadingPendingDelivery, setLoadingPendingDelivery] = useState(true);
  const [loadingCompliance, setLoadingCompliance] = useState(true);
  const [loadingHes, setLoadingHes] = useState(true);
  const [loadingDeliveryAverages, setLoadingDeliveryAverages] = useState(true);
  const [loadingQuantityMaterial, setLoadingQuantityMaterial] = useState(true);
  const [loadingBilling, setLoadingBilling] = useState(true);


  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const fetchAtcDashboardData = async (supplierIds = null, categories = null) => {
    try {
      setLoadingAtc(true);
      
      let criticityValue = null;
      
      if (categories && categories.length > 0) {
        if (categories.includes("Proveedores críticos") && !categories.includes("Proveedores no críticos")) {
          criticityValue = "Crítico";
        }
        else if (categories.includes("Proveedores no críticos") && !categories.includes("Proveedores críticos")) {
          criticityValue = "No Crítico";
        }
      }
      
      let supplierIdsArray = null;
      if (supplierIds) {
        if (typeof supplierIds === 'string') {
          supplierIdsArray = supplierIds.split(',').map(id => parseInt(id.trim()));
        } else if (Array.isArray(supplierIds)) {
          supplierIdsArray = supplierIds;
        }
      }
      
      const dashboardData = await getAtcDashboardData(
        supplierIdsArray && supplierIdsArray.length > 0 ? supplierIdsArray : null,
        criticityValue
      );

      
      setAtcData(dashboardData);
      
      const chartData = dashboardData.monthlyData.map(item => ({
        mes: item.month,
        emptyATC: item.emptyATC,
        rejectedATC: item.rejectedATC
      }));
      
      setAtcChartData(chartData);
    } catch (err) {
      console.error('Error fetching ATC dashboard:', err);
    } finally {
      setLoadingAtc(false);
    }
  };

  const fetchAdherenceData = async (supplierIds = null, categories = null) => {
    try {
      setLoadingAdherence(true);
      const response = await getUserAdherence(supplierIds, categories);
      setAdherenceData(response.data);
    } catch (error) {
      console.error("Error fetching adherence data:", error);
    } finally {
      setLoadingAdherence(false);
    }
  };

  const handleExport = async () => {
    setExporting(true);
    try {
      await exportExcelAdherence();
    } catch (e) {
      console.error(e);
    } finally {
      setExporting(false);
    }
  };

  const fetchPendingDeliveryData = async (supplierIds = null, categories = null) => {
    try {
      setLoadingPendingDelivery(true);
      const response = await getPendingDelivery(supplierIds, categories);
      setPendingDelivery(response.data);
    } catch (error) {
      console.error("Error fetching pending delivey data:", error);
    } finally {
      setLoadingPendingDelivery(false);
    }
  };

  const fetchComplianceIndicator = async (
    supplierIds = null, categories = null, startDate = null, endDate = null
  ) => {
    try {
      setLoadingCompliance(true);
      const avgResp = await getComplianceIndicator(
        supplierIds, categories, startDate, endDate
      );
      setComplianceIndicator(avgResp?.data?.percentage);
    } catch (err) {
      console.error('Error fetching compliance indicator:', err);
    } finally {
      setLoadingCompliance(false);
    }
  }

  const fetchHesEvaluation = async (supplierIds = null, categories = null) => {
    try {
      setLoadingHes(true);
      const hesResp = await getHesEvaluation(supplierIds, categories);
      setHesEvaluation(hesResp.data?.value);
    } catch (err) {
      console.error('Error fetching HES evaluation:', err);
    } finally {
      setLoadingHes(false);
    }
  }

  const fetchAverageDeliveryDays = async (supplierIds = null, categories = null) => {
    try {
      setLoadingDeliveryAverages(true);
      const avgResp = await getAverageDeliveryDays(supplierIds, categories);
      setDeliveryAverages(avgResp?.data?.delays);
    } catch (err) {
      console.error('Error fetching delivery averages:', err);
    } finally {
      setLoadingDeliveryAverages(false);
    }
  }

  const fetchQuantityMaterialOrders = async (supplierIds = null, categories = null, startDate = null, endDate = null) => {
    try {
      setLoadingQuantityMaterial(true);
      const qtyResp = await getQuantityMaterialOrders(
        supplierIds, categories, startDate, endDate
      );
      setQuantityMaterialOrders(qtyResp?.data);
    } catch (err) {
      console.error('Error fetching delivery averages:', err);
    } finally {
      setLoadingQuantityMaterial(false);
    }
  }

  const fetchBilling = async (supplierIds = null, categories = null, startDate = null, endDate = null) => {
    try {
      setLoadingBilling(true);
      const billResp = await getBilling(
        supplierIds, categories, startDate, endDate
      );
      setBilling(billResp?.data);
    } catch (err) {
      console.error('Error fetching billing:', err);
    } finally {
      setLoadingBilling(false);
    }
  }

const fetchEmptyAtcCount = async (
  supplierIds = null, 
  categories = null, 
  startDate = null, 
  endDate = null
) => {
  try {
    setLoadingAtc(true);
    
    let criticityValue = null;
    if (categories && categories.length > 0) {
      if (categories.includes("Proveedores críticos") && !categories.includes("Proveedores no críticos")) {
        criticityValue = "Crítico";
      }
      else if (categories.includes("Proveedores no críticos") && !categories.includes("Proveedores críticos")) {
        criticityValue = "No Crítico";
      }
    }
    
    const response = await getCountEmptyAtcs(
      startDate,
      endDate,
      supplierIds,
      criticityValue
    );
    
    setEmptyAtcCount(response);
  } catch (err) {
    console.error('Error obteniendo conteo de ATCs vacías:', err);
  } finally {
    setLoadingAtc(false);
  }
};


const getDefaultDateRange = () => {
  const today = new Date();
  const twelveMonthsAgo = new Date();
  twelveMonthsAgo.setMonth(today.getMonth() - 12);
  
  return {
    startDate: format(twelveMonthsAgo, 'yyyy-MM-dd'),
    endDate: format(today, 'yyyy-MM-dd')
  };
};

  const resetFilterValues = () => {
    setSelectedCategories(null);
    setSelectedSuppliers(null);
    setActiveDates(getDefaultDateRange());
    setAppliedFilters({});
  }

  const handleApply = () => {

  const defaultDates = getDefaultDateRange();
  const startDate = activeDates?.startDate || defaultDates.startDate;
  const endDate = activeDates?.endDate || defaultDates.endDate;
  const hasCustomDates = startDate !== defaultDates.startDate || endDate !== defaultDates.endDate;

  setAppliedFilters({
    supplierIds: selectedSuppliers || [],
    areas: selectedCategories || [],
    ...(hasCustomDates && { dateFrom: startDate, dateTo: endDate })
  });

    const suppliersStr = selectedSuppliers?.join(",");
    const categoriesStr = selectedCategories?.join(",");


    let supplierIdsArray = selectedSuppliers;
    if (typeof selectedSuppliers === 'string') {
      supplierIdsArray = selectedSuppliers.split(',').map(id => parseInt(id.trim()));
    }

    fetchAtcDashboardData(selectedSuppliers, selectedCategories);
    fetchEmptyAtcCount(supplierIdsArray, selectedCategories, startDate, endDate); 
    fetchAdherenceData(selectedSuppliers, categoriesStr);
    fetchPendingDeliveryData(suppliersStr, categoriesStr);
    fetchComplianceIndicator(suppliersStr, categoriesStr, startDate, endDate);
    fetchHesEvaluation(suppliersStr, categoriesStr);
    fetchAverageDeliveryDays(suppliersStr, categoriesStr);
    fetchQuantityMaterialOrders(suppliersStr, categoriesStr, startDate, endDate);
    fetchBilling(suppliersStr, categoriesStr, startDate, endDate);
  };

  const initialFetch = () => {
  const defaultDates = getDefaultDateRange();

    fetchAtcDashboardData(null, null); 
    fetchEmptyAtcCount(null, null, defaultDates.startDate, defaultDates.endDate); 
    fetchAdherenceData();
    fetchPendingDeliveryData();
    fetchComplianceIndicator(null, null, defaultDates.startDate, defaultDates.endDate);
    fetchHesEvaluation();
    fetchAverageDeliveryDays();
    fetchQuantityMaterialOrders(null, null, defaultDates.startDate, defaultDates.endDate);
    fetchBilling(null, null, defaultDates.startDate, defaultDates.endDate);
  }

  useEffect(() => {
    resetFilterValues();
    initialFetch();
  }, [resetFlag]);

  useEffect(() => {
    initialFetch();
  }, []);

  return (
    <div>
      <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300" />
      <div className={`flex-1 transition-all duration-300 ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"} pt-[67px] bg-[#F7F8F9] w-full z-50 min-h-screen`}>
        <div className="pt-4 pb-10 px-[3%] flex flex-col gap-4">
          <div className="flex flex-col items-center justify-between w-full gap-2 md:flex-row">
            <h2 className="text-blue flex text-2xl md:text-[32px] font-itcbold">Dashboard</h2>
            <div className="flex items-center gap-4">
              <ResetFilters borderColor="border-[#5CBDEB]" textColor="text-[#52526C]" onClick={() => setResetFlag(!resetFlag)} />
              <ListFilter
                titleOption="Filtros"
                textColor="#52526C"
                classname="w-[100px] font-itcmedium"
                showCategoryFilter={true}
                filters={filterOptions}
                titleCategory="Categoría de proveedor:"
                categoryOptions={["Proveedores críticos", "Proveedores no críticos", "Todas"]}
                onCategoryChange={setSelectedCategories}
                onSuppliersChange={setSelectedSuppliers}
                onDateRangeChange={setActiveDates}
                applyFilters={handleApply}
                resetFlag={resetFlag}
                activeFilters={appliedFilters}
                position="right-0"
              />
            </div>
          </div>
         
          <BarChartData
            title="Frecuencia de adherencia"
            chartTitle=""
            data={adherenceData}
            xAxisDataKey="month"
            yAxisLabel="Cantidad de accesos"
            height={277}
            tooltipLabelFormatter={month => `Mes: ${month}`}
            barLabelFormatter={value => value}
            showLegend={false}
            bars={[
              {
                dataKey: 'count',
                name: 'Cantidad',
                fill: '#184A7D',
                label: false
              }
            ]}
            barsize={30}
            loading={loadingAdherence}
            extra={
              <button
                onClick={handleExport}
                disabled={exporting}
                className={`flex items-center gap-2 bg-[#184A7D] text-white px-3 py-1 rounded-lg transition ${
                  exporting ? "opacity-70 cursor-not-allowed" : "hover:bg-[#0f3050]"
                }`}
              >
                {exporting ? (
                  <>
                    <span className="w-4 h-4 border-2 border-white rounded-full border-t-transparent animate-spin"></span>
                    <span>Exportando...</span>
                  </>
                ) : (
                  <>Exportar Excel</>
                )}
              </button>
            }
          />
          <BarChartData
            title="Pendientes de entrega"
            chartTitle=""
            xAxisDataKey="month"
            tooltipLabelFormatter={month => `Mes: ${month}`}
            height={277}
            bars={[
              { dataKey: 'newCount', name: 'Posiciones con fecha de entrega a Tiempo', fill: '#769B40', label: false },
              { dataKey: 'pendingCount', name: 'Posiciones con fecha de entrega por vencer', fill: '#FFC000', label: false },
              { dataKey: 'expiredCount', name: 'Posiciones con fecha de entrega vencida', fill: '#BD002A', label: false }
            ]}
            data={pendingDelivery}
            showLegend={true}
            barGap={6}
            barCategoryGap="15%"
            loading={loadingPendingDelivery}
          />

          <BarChartATC
            title="Indicador de ATC"
            chartTitle=""
            xAxisDataKey="mes"
            tooltipLabelFormatter={mes => `Mes: ${mes}`}
            height={300}
            bars={[
              { 
                dataKey: 'emptyATC', 
                name: 'ATC Vacías', 
                fill: '#58B6E5', 
                label: true 
              },
              { 
                dataKey: 'rejectedATC', 
                name: 'ATC Rechazadas', 
                fill: '#BD002A', 
                label: true 
              }
            ]}
            data={atcChartData}
            showLegend={true}
            barGap={8}
            barCategoryGap="15%"
            loading={loadingAtc}
            atcSummary={atcData}
          />
          
          <div className="grid items-start grid-cols-1 gap-4 md:grid-cols-3 ">
            <IndicatorGauge
              value={complianceIndicator}
              title="Indicador de cumplimiento de Materiales"
              description="Tu nivel de cumplimiento es de"
              color="#007696"
              loading={loadingCompliance}
            />
            <IndicatorGauge
              value={hesEvaluation}
              title="Indicador de HES de Servicios"
              description="Tu nivel de cumplimiento es de"
              color="#769B40"
              loading={loadingHes}
            />

            <AtcVaciasChart
              vaciasCount={emptyAtcCount?.totalEmptyAtcs} 
              loading={loadingAtc}
            />

          </div>
          <div className="grid items-start grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
            <PieChartOrders
              delivered={quantityMaterialOrders?.deliveredPercentage}
              pending={quantityMaterialOrders?.pendingPercentage}
              expired={quantityMaterialOrders?.expiredPercentage}
              loading={loadingQuantityMaterial}
              roleId={roleId}
            />
            <PieChartBilling
              delivered={billing && billing.billed}
              pending={billing && billing.pending}
              loading={loadingBilling}
            />

            <DeliveryAverageChart
              averageDays={deliveryAverages && deliveryAverages[0]?.average}
              previousYear1={deliveryAverages && deliveryAverages[1]}
              previousYear2={deliveryAverages && deliveryAverages[2]}
              loading={loadingDeliveryAverages}
            />
          </div>
          {/* <BarChartData
            title="Pendientes de entrega"
            data={adherenceData}
            xAxisDataKey="month"
            barDataKey="count"
            // xAxisLabel="Meses del año"
            yAxisLabel="Cantidad de accesos"
            // barName="Logueos"
            height={277}
            tooltipFormatter={(value) => [`${value} accesos`, 'Cantidad']}
            tooltipLabelFormatter={(month) => `Mes: ${month}`}
            barLabelFormatter={(value) => value}
          /> */}

          {/* <div className="grid grid-cols-1 gap-3 lg:gap-[10%]  md:grid-cols-3">
            <IndicatorGauge
              value={83}
              title="Indicador de cumplimiento"
              description="Tu nivel de cumplimiento es de"
              color="#007696"
            />
            <IndicatorGauge
              value={30}
              title="Indicador de HES"
              description="Tu nivel de cumplimiento es de"
              color="#769B40"
            />
            <IndicatorGauge
              value={60}
              title="Promedio de ATC"
              description="El promedio de ATC es de"
              color="#6A57FF"
            />
          </div>
          <div className="grid grid-cols-1 pt-6 gap-3 lg:gap-[10%] md:grid-cols-3">
            <PieChartOrders
              delivered={60}
              pending={25}
              expired={15}
            />
            <DeliveryAverageChart averageDays={6} />

            <PieChartBilling
              delivered={30}
              pending={60}
              expired={10}
            />
          </div> */}
        </div>
      </div>
    </div>
  );
}